/**
 * Central definition of material colors for the inventory map
 * These colors are used consistently across the application for material highlighting
 */
export const MATERIAL_COLORS = [
  '#e91e63', '#9c27b0', '#3f51b5', '#2196f3', '#00bcd4',
  '#009688', '#4caf50', '#8bc34a', '#cddc39', '#ffeb3b',
  '#ffc107', '#ff9800', '#ff5722', '#795548', '#9e9e9e',
  '#f44336', '#e57373', '#ba68c8', '#9575cd', '#7986cb',
  '#64b5f6', '#4fc3f7', '#4dd0e1', '#4db6ac', '#81c784',
  '#aed581', '#dce775', '#fff176', '#ffd54f', '#ffb74d'
];

/**
 * Default color for bins without material data
 */
export const DEFAULT_MATERIAL_COLOR = '#9e9e9e';

/**
 * Creates a color mapping for materials
 * @param {Array} materials - Array of unique material names
 * @returns {Object} Object mapping material names to colors
 */
export function createMaterialColorMap(materials) {
  const colorMap = {};
  materials.forEach((material, index) => {
    colorMap[material] = MATERIAL_COLORS[index % MATERIAL_COLORS.length];
  });
  return colorMap;
}
